import type { CharacterCatalog, CatalogRecord } from "../domain/types";

type JsonModule<T> = { default: T };

const loadManifest = () =>
  import("./manifest.json") as Promise<JsonModule<{ version: string }>>;
const loadSpecial = () =>
  import("./special.json") as Promise<JsonModule<CatalogRecord[]>>;
const loadSkills = () =>
  import("./skills.json") as Promise<JsonModule<CatalogRecord[]>>;
const loadEquipment = () =>
  import("./equipment.json") as Promise<JsonModule<CatalogRecord[]>>;
const loadEquipmentSets = () =>
  import("./equipment_sets.json") as unknown as Promise<
    JsonModule<Record<string, Array<Record<string, unknown>>>>
  >;
const loadOrigins = () =>
  import("./origins.json") as Promise<JsonModule<CatalogRecord[]>>;
const loadPerks = () =>
  import("./perks.json") as Promise<JsonModule<CatalogRecord[]>>;

let catalogPromise: Promise<CharacterCatalog> | undefined;

/** Catalog chunks are requested only after a rule-driven character tab opens. */
export function loadCharacterCatalog(): Promise<CharacterCatalog> {
  catalogPromise ??= Promise.all([
    loadManifest(),
    loadSpecial(),
    loadSkills(),
    loadEquipment(),
    loadEquipmentSets(),
    loadOrigins(),
    loadPerks(),
  ]).then(
    ([
      manifest,
      special,
      skills,
      equipment,
      equipmentSets,
      origins,
      perks,
    ]) => ({
      version: manifest.default.version,
      special: special.default,
      skills: skills.default,
      equipment: equipment.default,
      equipment_sets: equipmentSets.default,
      origins: origins.default,
      perks: perks.default,
    }),
  );
  return catalogPromise;
}
